export enum FeatureType {
  CONNECT_RECRUITERS = 'connect_recruiters',
  FREE_RECRUITER_CONNECTIONS = 'free_recruiter_connections_enabled',
  CONNECT_CLIENTS_LIMIT = 'connect_clients',
  CONNECT_CANDIDATES_LIMIT = 'connect_candidates',
  TOB_ENABLED = 'connection_tob_enabled',
  LIVE_ACTIVITY_ALERTS = 'live_activity_alerts',
  PAST_CANDIDATE_UPDATES_ENABLED = 'past_candidate_updates_enabled',
  OPERATIONAL_ROLES_ENABLED = 'operational_roles_enabled',
  CREATE_DEPARTMENTS_LIMIT = 'create_departments',
  TEAM_SEAT_LIMIT = 'team_seat',
  CREATE_JOBS_LIMIT = 'create_jobs',
  MANAGE_INTERNAL_JOBS_ENABLED = 'manage_internal_jobs',
  INTEGRATIONS_ENABLED = 'integrations_enabled',
  INTERVIEW_SCHEDULING_ENABLED = 'interview_scheduling',
  JOB_INVITES_ENABLED = 'job_invites',
  SUB_ORG_ENABLED = 'sub_organization_enabled',
  SUB_ORG_TEAM_SEAT_LIMIT = 'sub_organization_team_seat',
  JOB_BOARD_ENABLED = 'job_board_enabled',
  ADD_CANDIDATE_LIMIT = 'add_candidates',

  JOB_DESCRIPTION_AI_FEATURE_ENABLED = 'job_description_ai_feature_enabled',
  PROFILE_SUMMARY_AI_FEATURE_ENABLED = 'profile_summary_ai_feature_enabled',

  EMAIL_CONNECTOR_ENABLED = 'email_connector_enabled',

  DEAL_FLOW_ENABLED = 'deal_flow_enabled', // whether deal flow is enabled for the tenant

  TASK_MANAGEMENT_ENABLED = 'task_management_enabled', // whether task management is enabled for the tenant

  ORG_BRANDING_ENABLED = 'org_branding_enabled', // whether organization branding is enabled
  REFERENCE_TEMPLATES_ENABLED = 'reference_templates_enabled', // whether reference templates are enabled for the tenant
  REJECTION_TEMPLATES_ENABLED = 'rejection_templates_enabled', // whether rejection templates are

  JOB_SCREENING_QUESTIONS_ENABLED = 'job_screening_questions_enabled', // whether job screening questions are enabled for the tenant
  LISTS_ENABLED = 'lists_enabled', // whether lists are enabled for the tenant,

  CUSTOM_FIELDS_ENABLED = 'custom_fields_enabled', // whether custom fields are enabled for the tenant,

  CALENDAR_ENABLED = 'calendar_enabled', // whether calendar is enabled for the tenant,

  EVENT_SCHEDULING_ENABLED = 'event_scheduling_enabled', // whether event scheduling is enabled for the tenant

  MEETINGS_ENABLED = 'meetings_enabled', // whether meetings are enabled for the tenant

}